import { usePageData } from "../../../contexts/PageData";

import MainRepairView from "./MainRepair";

import TimlineWithComments from "../../../utils/utilities/Timeline/TimelineWithComments";
import AccessTimeIcon from '@mui/icons-material/AccessTime';

import { Grid, Card, CardContent, CardHeader } from "@mui/material";

const HistoryTab = () => {
  const { data } = usePageData() || {};
  return (
   <Grid container spacing={3}>
    <Grid size={{xs: 12, md: 8, lg: 6}}>
      <Card variant='outlined'>
        <CardHeader title="Repair Timeline" action={<AccessTimeIcon />} />
        <CardContent sx={{pt: 1}}>
          <TimlineWithComments resource="repair_ticket" resource_id={data?.repair_ticket_id} expand={true} />
        </CardContent>
      </Card>
    </Grid>
   </Grid>
  )
};

export default HistoryTab;